import React, { useContext, useState } from 'react';
import { Typography } from 'antd';
import { PiSeatbeltBold } from 'react-icons/pi';
import AlertCard from './AlertCard';
import { ALERT_CATEGORY, triggerAlert } from '../../mqtt/aws';
import { SimulatorContext } from 'store/context';

const { Text } = Typography;

const SeatBeltAlert = ({ messageApi, onTriggered }) => {
  const { stsToken: credentials, vehicleSimulatorSettings: { serialNo, vehicleKey } } = useContext(SimulatorContext);
  const [loading, setLoading] = useState(false);

  const triggerSeatBeltAlert = async () => {
    setLoading(true);
    await triggerAlert({ serialNo, vehicleKey, actual: '', threshold: '', category: ALERT_CATEGORY.SEAT_BELT_ALERT }, credentials)
      .then(() => { messageApi.success('Seat belt alert triggered successfully'); onTriggered?.({ success: true, value: null }); })
      .catch(() => { messageApi.error('Failed to trigger seat belt alert'); onTriggered?.({ success: false, value: null }); })
      .finally(() => setLoading(false));
  };

  return (
    <AlertCard
      index={9}
      title="Seat Belt Unfastened"
      icon={<PiSeatbeltBold />}
      iconBg="#eff6ff"
      iconColor="#2563eb"
      onTrigger={triggerSeatBeltAlert}
      triggerLabel="Trigger Seat Belt Alert"
      loading={loading}
    >
      <div
        style={{
          padding: '10px 12px',
          borderRadius: 8,
          background: '#fff5f5',
          border: '1px solid #fca5a5',
          display: 'flex',
          alignItems: 'center',
          gap: 8,
        }}
      >
        <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#ef4444', flexShrink: 0 }} />
        <Text style={{ fontSize: 12, color: '#dc2626', fontWeight: 500 }}>
          Triggered when seat belt sign is active
        </Text>
      </div>
    </AlertCard>
  );
};

export default SeatBeltAlert;
